<template>
  <div class="part">
    <div class="info">
      <div class="title">
        联系方式<span class="small">CONTACT US</span>
      </div>
      <div class="cell">
        <i class="icon-tel"></i>
        联系电话  186 8021 1000
      </div>
      <div class="cell">
        <i class="icon-mail"></i>
        电子邮箱  chenjianjun@xcxzhan.com
      </div>
      <!--二维码-->
      <div class="qrcode">
        <img src="~../../assets/images/minicard.jpg" alt="">
        <img src="~../../assets/images/miniweb.jpg" alt="" >
      </div>
      <div class="small" style = "float: left;">扫码试用小名片</div>
      <div class="small"  style = "float: left; margin-left: 120px;">扫码创建小官网</div>
    </div>
    <!--表单数据-->
    <div class="form">
      <div class="title">
        招商加盟<span class="small">CHINA MERCHANTS TO JOIN </span>
      </div>
      <div class="cell cell1">

        <input type="text" placeholder="联系人" v-model="realname">
      </div>
      <div class="cell cell2">

        <input type="text" placeholder="电话" v-model='mobile'>
      </div>
      <div class="cell cell1 speical">

        <input type="text" placeholder="意向代理城市" v-model="address">
      </div>
      <div class="cell cell2">

        <input type="text" placeholder="邮箱" v-model="email">
      </div>
      <!--按钮-->
      <div class="control">
        <button class="btn btn-submit" @click="submit">{{submitting ? '提交申请中...' : '提交申请'}}</button>
        <span class="mark">(我们会在48小时内与您联系)</span>
      </div>
    </div>
    <success ref="dialog"></success>
  </div>
</template>

<script type="text/ecmascript-6">
import { invest } from "../../../siteindex/api"
import Success from "../../../siteindex/join-success"
let isEmail = require('outils/isEmail')
let isPhone = require('outils/isPhoneNum')
export default {
  data() {
    return {
      realname: '',
      mobile: '',
      address: '',
      email: '',
      submitting: false
    }
  },
  methods: {
    verify(data){
      if(!data.realname) return '请填写您的名字'
      if(!isPhone(data.mobile)) return '请填写您的联系电话'
      if(!isEmail(data.email)) return '请填写您的邮箱'
    },
    submit(){
      if(this.submitting) return
      let data = {
        realname: this.realname,
        mobile: this.mobile,
        address: this.address,
        email: this.email
      }
      let result = this.verify(data)
      if(result){
        window.alert(result)
        return
      }
      this.submitting  = true
      invest(data).then(() => {
        this.$refs.dialog.show(true)
        this.submitting  = false
      }).catch(err => {
        this.submitting  = false
      })

    }
  },
  components: {
    Success
  }
}
</script>

<style scoped lang="scss">
@import "../../common/common.scss";
.part{
  width: 100%;
  min-width: $min-width;
  max-width: 1200px;
  margin: 0 auto;
  line-height: 1.0;
  @include clearfix;
  text-align: left;
  padding-bottom: 140px;
  position: relative;
  .info{
    float: left;
    padding-top: 74px;
    position: relative;
    z-index: 1;
    @media screen and (max-width:1200px) and (min-width: $min-width) {
      margin-left: 20px;
    }
    @media screen and (max-width:$min-width) {
      display:none;
    }
    .title{
      width: 340px;
      margin-bottom: 48px;
    }
    .cell{
      font-size: 18px;
      & + .cell{
        margin-top: 30px;
      }
    }
    .icon-tel{
      display: inline-block;
      width: 23px;
      height: 20px;
      background-image: url("../../assets/images/tel.png");
      vertical-align: middle;
      margin-right: 20px;
    }
    .icon-mail{
      display: inline-block;
      width: 24px;
      height: 20px;
      background-image: url("../../assets/images/mail.png");
      vertical-align: middle;
      margin-right: 20px;
    }
    .qrcode{
      margin-top: 46px;
      margin-bottom: 20px;
      img{
        width: 120px;
        height: 120px;
      }
      img + img{
        margin-left: 60px;
        transform: scale(1.3);
      }
    }
    .small{
      color:#999;
      font-size: 12px;
    }

  }
  .form{
    float: left;
    margin-left: 40px;
    padding: 74px 100px 66px 60px;
    box-shadow: 0 0 14px rgba(0,0,0,.1);
    width: 640px;
    @include clearfix;
    background-color:#fff;
    position: relative;
    z-index: 1;
    @media screen and (max-width:1230px) and (min-width: 1100px) {
      padding-left: 20px;
      padding-right: 20px;
      margin-left: 40px;
    }
    @media screen and (max-width:1100px) and (min-width: $min-width) {
      padding-left: 0;
      padding-right: 0;
      margin-left: 0;
    }
    @media screen and (max-width:$min-width) {
      margin: 0 auto;
    }
    .title{
      width: 100%;
      margin-bottom: 42px;
    }
    .cell{
      font-size: 16px;
      color:#999;
      line-height: 48px;
      border: 1px solid #ccc;
      background-color:#fefefe;
      float: left;
      box-sizing: border-box;
      padding: 0 14px;
      margin-bottom: 20px;
      input{
        margin-left: 10px;
      }
      &:nth-of-type(2n+1){
        margin-left: 15px;
      }
      &.cell1{
        width: 240px;
        input{
          width: 100%;
        }
      }
      &.cell2{
        width: 380px;
        input{
          width: 100%;
        }
      }
      /*
      &.speical{
        input{
          width: 90px;
        }
      }*/
    }
    .control{
      margin-top: 50px;
      float: left;
      .btn-submit{
        width: 180px;
        text-align: center;
        color:#fff;
        background-color:#2cbb58;
        font-size: 20px;
        line-height: 44px;
        vertical-align: bottom;
        border-radius: 4px;
      }
      .mark{
        font-size: 18px;
        color:#999;
        vertical-align: bottom;
        margin-left: 24px;
        line-height: 1.4;
      }
    }
  }
  .title{
    font-size: 36px;
    color:#2cbb58;
    vertical-align: bottom;
    padding-bottom: 20px;
    border-bottom: 1px solid #ccc;
    position: relative;
    &::after{
      content: '';
      display: block;
      height: 0 ;
      width: 118px;
      border-bottom: 1px solid #1e1e1e;
      position: absolute;
      left: 0;
      bottom: -1px;
    }
    .small{
      font-size: 16px;
      vertical-align: bottom;
      margin-left: 16px;
    }
  }
  &::before{
    content: '';
    display: block;
    width: 1914px;
    height: 477px;
    position: absolute;
    bottom: 0;
    left: -350px;
    background-image: url("../../assets/images/join.png");
  }

}
</style>



// WEBPACK FOOTER //
// src/apps/zcx/components/business/join.vue